parent.postMessage(location.hash, location.origin);
